module.exports = __webpack_public_path__ + "img/faq.0b1599ec.jpg";